import { AudioManager } from "../../AudioManager";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Button";
import { CalendarButton } from "./CalendarButton";
import { SplashScene } from "./SplashScene";

export class CalendarLayer extends Phaser.GameObjects.Container {

    private static MONTH_KEYS = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];
    private static DELTA_X = 122;
    private static DELTA_Y = 110;

    private dayButtons: CalendarButton[];
    private month: number;
    private year: number;
    private monthLabel: Phaser.GameObjects.Text;
    private leftArrowButton: Button;
    private rightArrowButton: Button;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        this.month = GameVars.today.month;
        this.year = GameVars.today.year;

        this.x = 300 * GameVars.scaleX;
        this.y = 160;
        this.scaleX = .64 * GameVars.scaleX;
        this.scaleY = .64;

        const levelTitleBackground = new Phaser.GameObjects.Image(this.scene, -370, -200, "texture_atlas_1", "tab_boards_daily_games");
        levelTitleBackground.setOrigin(0);
        levelTitleBackground.scale = 1 / this.scale;
        this.add(levelTitleBackground);

        const dailyGamesLabel = new Phaser.GameObjects.Text(this.scene, levelTitleBackground.x + 30, levelTitleBackground.y + 20, gameText["DAILY_GAMES"][lan], {fontFamily: "OpenSans-CondLight", fontSize: "62px", color: "#7C5D46"});
        dailyGamesLabel.setOrigin(0);
        this.add(dailyGamesLabel);

        const monthsBackfround = new Phaser.GameObjects.Graphics(this.scene, { fillStyle: { color: 0xD5BEA7, alpha: .2 } });

        // Comenzar un nuevo camino
        monthsBackfround.beginPath();

        // Mover al punto de inicio
        monthsBackfround.moveTo(30, 0);

        // Dibujar la línea superior y las esquinas redondeadas superiores
        monthsBackfround.lineTo(840 - 30, 0); // línea superior hasta la esquina superior derecha
        monthsBackfround.arc(840 - 30, 30, 30, 1.5 * Math.PI, 2 * Math.PI); // esquina superior derecha
        monthsBackfround.lineTo(840, 100); // línea derecha
        monthsBackfround.lineTo(0, 100); // línea inferior
        monthsBackfround.lineTo(0, 30); // línea izquierda
        monthsBackfround.arc(30, 30, 30, Math.PI, 1.5 * Math.PI); // esquina superior izquierda

        // Cerrar el camino y rellenarlo
        monthsBackfround.closePath();
        monthsBackfround.fillPath();
        monthsBackfround.x = -420;
        monthsBackfround.y = 75;
        this.add(monthsBackfround);

        const daysBackground = new Phaser.GameObjects.Graphics(this.scene);
        daysBackground.fillStyle(0xD5BEA7, .2);
        daysBackground.fillRect(-420, 190, 840, 75);
        this.add(daysBackground);

        this.dayButtons = [];

        const month = gameText[CalendarLayer.MONTH_KEYS[this.month - 1]][lan];

        this.monthLabel = new Phaser.GameObjects.Text(this.scene, 0, 130, month, {fontFamily: "OpenSans-CondLight", fontSize: "80px", color: "#7C5D46"});
        this.monthLabel.setOrigin(.5);
        this.add(this.monthLabel);

        this.leftArrowButton = new Button(this.scene, -375, this.monthLabel.y, "texture_atlas_1", "btn_arrow_off", "btn_arrow_off");
        this.leftArrowButton.scaleX = -1;
        this.leftArrowButton.onUp(function(): void {
            this.onClickArrowButton(false);
        }, this);
        this.add(this.leftArrowButton);

        this.rightArrowButton = new Button(this.scene, -this.leftArrowButton.x, this.monthLabel.y, "texture_atlas_1", "btn_arrow_off", "btn_arrow_off");

        this.rightArrowButton.onUp(function(): void {
            this.onClickArrowButton(true);
        }, this);
        this.add(this.rightArrowButton);

        // LOS DIAS DE LA SEMANA
        // const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
        const DAY_KEYS = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];

        DAY_KEYS.forEach((day, index) => {

            const dayStr = gameText[day][lan];

            const dayLabel = new Phaser.GameObjects.Text(this.scene, -365 + index * CalendarLayer.DELTA_X, 230, dayStr, {fontFamily: "OpenSans-CondLight", fontSize: "44px", color: "#644329"});
            dayLabel.setOrigin(.5);
            this.add(dayLabel);
        });

        for (let r = 0; r < 6; r++) {
            for (let c = 0; c < 7; c++) {

                const x = 5 + (c - 3) * CalendarLayer.DELTA_X;
                const y = 325 + CalendarLayer.DELTA_Y * r;

                const dayButton = new CalendarButton(this.scene, x, y);   
                dayButton.setDay(c);
                this.add(dayButton);
               
                this.dayButtons.push(dayButton);
            }
        }
   
        this.configureDays();
        this.markToday();
    }

    private configureDays(): void {

        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const calendar = require("node-calendar");

        let monthRange = calendar.monthrange(this.year, this.month);

        const startingDay = monthRange[0];
        const daysMonth = monthRange[1];

        let j = 1;

        for (let i = startingDay; i < startingDay + daysMonth; i++) {
            this.dayButtons[i].setDay(j);
            this.dayButtons[i].name = JSON.stringify({ day: j, month: this.month, year: this.year });
            j ++;
        }

        // // ponemos los numeros en ultimos dias del mes anterior
        let previousMonthYear: number;
        let previousMonth: number;

        if (this.month === 1) {
            previousMonthYear = this.year - 1;
            previousMonth = 12;
        } else {
            previousMonthYear = this.year;
            previousMonth = this.month - 1;
        }

        monthRange = calendar.monthrange(previousMonthYear, previousMonth);
        j = 0;
        for (let i = startingDay - 1; i >= 0; i--) {
            this.dayButtons[i].setDay(monthRange[1] - j);
            this.dayButtons[i].name = JSON.stringify({ day: monthRange[1] - j, month: previousMonth, year: previousMonthYear });
            j ++;
        }

        // los numeros del mes siguiente
        let nextMonthYear: number;
        let nextMonth: number;

        if (this.month === 12) {
            nextMonthYear = this.year + 1;
            nextMonth = 1;
        } else {
            nextMonthYear = this.year;
            nextMonth = this.month + 1;
        }

        j = 1;

        for (let i = startingDay + daysMonth; i < this.dayButtons.length; i++) {
            this.dayButtons[i].setDay(j);
            this.dayButtons[i].name = JSON.stringify({ day: j, month: nextMonth, year: nextMonthYear });
            j ++;
        }
    }

    private markToday(): void {

        // Los botones de días futuros llevan el alpha a 50%.
        // Los btns de días de los meses anteriores y posteriores llevan el alpha del número al 50%.

        const todayDate = JSON.stringify(GameVars.today);

        for (let i = 0; i < this.dayButtons.length; i++) {

            if (todayDate === this.dayButtons[i].name) {
                this.dayButtons[i].markToday();
            } else {
                this.dayButtons[i].unMarkToday();
            }

            // mirar si es un dia de un mes anterior o posterior
            const buttonDate = JSON.parse(this.dayButtons[i].name);

            if (buttonDate.month === GameVars.today.month) {
                this.dayButtons[i].markCurrentMonth();
            } else {
                this.dayButtons[i].unMarkCurrentMonth();
            }

            if (
                buttonDate.year > GameVars.today.year || 
                (buttonDate.year === GameVars.today.year && buttonDate.month > GameVars.today.month) ||
                (buttonDate.year === GameVars.today.year && buttonDate.month === GameVars.today.month && buttonDate.day > GameVars.today.day)
                ) {
                this.dayButtons[i].markFutureDay();
            } else {
                this.dayButtons[i].unMarkFutureDay();
            }
        }
    }   

    private onClickArrowButton(isRightButton: boolean): void {

        if (SplashScene.currentInstance.categoryLayer !== null || SplashScene.currentInstance.firstSessionLayer !== null || SplashScene.currentInstance.brandingLayer !== null || SplashScene.currentInstance.transitioning) {
            return;
        }

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        let month: number;
        let year = this.year;

        if (isRightButton) {

            if (this.month === 12) {
                month = 1;
                year ++;
            } else {
                month = this.month + 1;
            }

        } else {

            if (this.month === 1) {
                month = 12;
                year --;
            } else {
                month = this.month - 1;
            }
        }

        // TODO: MIRAR SI ESTAMOS DENTRO DE MEDIO AÑO DELANTE O DETRAS DEL DIA DE HOY
        const today = new Date();
        const proposedDate = new Date(year, month, today.getDate());

        const oneDay = 1000 * 60 * 60 * 24;
        const deltaDays = Math.floor((proposedDate.getTime() - today.getTime()) / oneDay) - 30;

        if (Math.abs(deltaDays) <= 31) {

            this.month = month;
            this.year = year;

            this.monthLabel.text = gameText[CalendarLayer.MONTH_KEYS[this.month - 1]][lan];

            this.configureDays();
            this.markToday();

            if (deltaDays > 0) {
                this.rightArrowButton.visible = false;
                this.leftArrowButton.visible = true;
            } else if (deltaDays < -5) {
                this.rightArrowButton.visible = true;
                this.leftArrowButton.visible = false;
            } else {
                this.rightArrowButton.visible = true;
                this.leftArrowButton.visible = true;
            }
        }

        AudioManager.playSound("btn_press");
    }
}
